import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { classPrefixes: Array }

  changeButtonAttribute(event) {
    event.preventDefault();

    const { value, styleAttribute } = this.getDataset(event);

    this.classPrefixesValue.forEach(classPrefix => {
      this.forEachItem(classPrefix, (item) => {
        item.style[styleAttribute] = value;
      });
    });
  };

  changeClassStyle(event) {
    event.preventDefault();
    
    const { value } = this.getDataset(event);

    this.classPrefixesValue.forEach(classPrefix => {
      const classValue = `${classPrefix}-${value}`;

      this.forEachItem(classPrefix, (item) => {
        const foundClass = this.findClassByPrefix(item, classPrefix);

        if (foundClass) {
          item.classList.remove(foundClass);
        };

        item.classList.add(classValue);
      });
    });
  };

  getPhonePreview() {
    return document.getElementById("phone-preview");
  };

  getDataset(event) {
    const { value, styleAttribute } = event.currentTarget.dataset;
    return { value, styleAttribute };
  };

  forEachItem(classPrefix, callback) {
    const phonePreview = this.getPhonePreview();

    phonePreview.querySelectorAll(".row").forEach(row => {
      const items = row.querySelectorAll(`[class*="${classPrefix}"]`);
      items.forEach(callback);
    });
  };

  findClassByPrefix(element, prefix) {
    return [...element.classList].find(c => c.startsWith(prefix));
  };
};